import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getBreakpointState = createSelector(
  getDragonflySharedState,
  (state) => state.breakpoint
);

export const getScreenSize = createSelector(
  getBreakpointState,
  ({ size }) => size
);
